import nudgeStore from '../store/Store';
import shouldShowAsSpotlight from './shouldShowAsSpotlight';

export default function getNudgesCount(tableViewId: string): number {
    return nudgeStore.nudgedRows.filter(nudgedRow => {
        // If a row is shown as spotlight, don't count it towards count of nudges.
        if (shouldShowAsSpotlight(nudgedRow.rowKey, nudgedRow.tableViewId)) {
            return false;
        }

        return nudgedRow.tableViewId === tableViewId;
    }).length;
}
